// Klaviyo regenerates rich-text IDs. Hide only the two duplicated introductory
// rows by their complete known text; consent, fields and validation stay native.
(() => {
  const introCopy = new Set([
    'Join Our Community',
    'Be the first to know about new collections, exclusive offers and encouraging stories.'
  ]);
  const normalize = (text) => text.replace(/[\u200B-\u200D\uFEFF]/g, '').replace(/\s+/g, ' ').trim();
  const initialize = (container) => {
    if (container.dataset.swfNewsletterObserved) return;
    container.dataset.swfNewsletterObserved = 'true';
    const update = () => {
      container.querySelectorAll('.klaviyo-form-TPs9nd [data-testid="form-row"]').forEach((row) => {
        const marketingOnly = !row.querySelector('input, button, select, textarea, a, [role="alert"], [aria-live]');
        row.classList.toggle('swf-newsletter-duplicate-intro', marketingOnly && introCopy.has(normalize(row.textContent || '')));
      });
    };
    update();
    const observer = new MutationObserver(update);
    observer.observe(container, { childList: true, subtree: true, characterData: true });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(container)) observer.disconnect();
    });
  };
  const start = () => document.querySelectorAll('.swf-brand-newsletter__form').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
